export default __webpack_public_path__ + "static/media/87.2559f01e.png";